<template>
  <div>
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div class="e-mtavr-15">თეთრი სიის პარამეტრები</div>
    </h4>

    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <b-card bg-variant="transparent" border-variant="secondary" class="shadow-none mb-4">
            <div class="card-title with-elements">
              <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                აირჩიე შედარების ალგორითმი
                <strong class="text-danger">ფიზიკური პირის</strong> შემთხვევაში
              </h5>
            </div>
            <label class="switcher switcher-square">
              <input type="checkbox" v-model="individual.logic1" class="switcher-input" />
              <span class="switcher-indicator">
                <span class="switcher-yes">
                  <span class="lnr lnr-checkmark-circle"></span>
                </span>
                <span class="switcher-no">
                  <span class="lnr lnr-cross-circle"></span>
                </span>
              </span>
              <span class="switcher-label e-nusx-8">
                მოთხოვნის შედარება მოხდეს
                <strong>სახელით</strong>,
                <strong>გვარით</strong> და
                <strong>პირადი N</strong>
              </span>
            </label>
            <hr class="border-light mt-3" />
            <label class="switcher switcher-square">
              <input type="checkbox" v-model="individual.logic2" class="switcher-input" />
              <span class="switcher-indicator">
                <span class="switcher-yes">
                  <span class="lnr lnr-checkmark-circle"></span>
                </span>
                <span class="switcher-no">
                  <span class="lnr lnr-cross-circle"></span>
                </span>
              </span>
              <span class="switcher-label e-nusx-8">
                მოთხოვნის შედარება მოხდეს
                <strong>სახელით</strong>,
                <strong>გვარით</strong> და
                <strong>დაბადების თარიღით</strong>
              </span>
            </label>
            <hr class="border-light mt-3" />
            <label class="switcher switcher-square">
              <input type="checkbox" v-model="individual.logic3" class="switcher-input" />
              <span class="switcher-indicator">
                <span class="switcher-yes">
                  <span class="lnr lnr-checkmark-circle"></span>
                </span>
                <span class="switcher-no">
                  <span class="lnr lnr-cross-circle"></span>
                </span>
              </span>
              <span class="switcher-label e-nusx-8">
                მოთხოვნის შედარება მოხდეს
                <strong>სახელით</strong> და
                <strong>გვარით</strong>
              </span>
            </label>
            <hr class="border-light mt-3" />
          </b-card>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <b-card bg-variant="transparent" border-variant="secondary" class="shadow-none mb-4">
            <div class="card-title with-elements">
              <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                მოქმედი შედარების ალგორითმი
                <strong class="text-danger">ფიზიკური პირის</strong> შემთხვევაში
              </h5>
            </div>
            <div class="callout callout-warning" v-if="!individual.logic1 && !individual.logic2 && !individual.logic3">
                <h5 class="e-mtavr-17">ყურადღება!</h5>
                <p class="e-nusx-8">ამ დროისათვის სისტემაში არ მოქმედებს მოთხოვნის თეთრ სიასთან შედარების არცერთი ლოგიკა.</p>
                <hr>
                <p class="e-nusx-8">გთხოვთ ყურადღებით აირჩიოთ თქვენთვის მისაღები ლოგიკა ერთი ან რამოდენიმე</p>
            </div>
            <div class="callout callout-success" v-else>
                <h5 class="e-mtavr-17">არჩევანის შესაბამისად მოთხოვნა თეთრ სიასთან შედარდება შემდეგი ლოგიკით</h5>
                <p class="e-nusx-8" v-if="individual.logic1"><strong>ლოგიკა 1</strong> - მოთხოვნის პარამეტრები შედარდება თეთრი სიის ჩანაწერის სახელს, გვარს და პირად ნომერს.</p>
                <hr v-if="individual.logic1">
                <p class="e-nusx-8" v-if="individual.logic1 && (individual.logic2 || individual.logic3)"><span class="badge badge-warning">ყურადღება</span> - <strong> ლოგიკა 1</strong>-ით ვერცერთი დამთხვევის გამოვლენისას ამოქმედდება შემდეგი ლოგიკა</p>
                <hr v-if="individual.logic1 && (individual.logic2 || individual.logic3)">
                <p class="e-nusx-8" v-if="individual.logic2"><strong>ლოგიკა 2</strong> - მოთხოვნის პარამეტრები შედარდება თეთრი სიის ჩანაწერის სახელს, გვარს და პირად ნომერს.</p>
                <hr v-if="individual.logic2">
                <p class="e-nusx-8" v-if="individual.logic2 && individual.logic3"><span class="badge badge-warning">ყურადღება</span> - <strong> ლოგიკა 2</strong>-ით ვერცერთი დამთხვევის გამოვლენისას ამოქმედდება შემდეგი ლოგიკა</p>
                <hr v-if="individual.logic2 && individual.logic3">
                <p class="e-nusx-8" v-if="individual.logic3"><strong>ლოგიკა 3</strong> - მოთხოვნის პარამეტრები შედარდება თეთრი სიის ჩანაწერის სახელს, გვარს და პირად ნომერს.</p>
                <hr v-if="individual.logic3">
                <p class="e-nusx-8"><strong>შერჩეული ლოგიკით პირდაპირი დამთხვევის შემთხვევაში შემოსული მოთხოვნა ავტომატურად დადასტურდება.</strong></p>
            </div>
          </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <b-card bg-variant="transparent" border-variant="secondary" class="shadow-none mb-4">
            <div class="card-title with-elements">
              <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                აირჩიე შედარების ალგორითმი
                <strong class="text-danger">იურიდიული პირის</strong> შემთხვევაში
              </h5>
            </div>
            <label class="switcher switcher-square">
              <input type="checkbox" v-model="juridical.logic1" class="switcher-input" />
              <span class="switcher-indicator">
                <span class="switcher-yes">
                  <span class="lnr lnr-checkmark-circle"></span>
                </span>
                <span class="switcher-no">
                  <span class="lnr lnr-cross-circle"></span>
                </span>
              </span>
              <span class="switcher-label e-nusx-8">
                მოთხოვნის შედარება მოხდეს
                <strong>დასახელებით</strong>
                და
                <strong>რეზიდენტობით</strong>
              </span>
            </label>
            <hr class="border-light mt-3" />
            <label class="switcher switcher-square">
              <input type="checkbox" v-model="juridical.logic2" class="switcher-input" />
              <span class="switcher-indicator">
                <span class="switcher-yes">
                  <span class="lnr lnr-checkmark-circle"></span>
                </span>
                <span class="switcher-no">
                  <span class="lnr lnr-cross-circle"></span>
                </span>
              </span>
              <span class="switcher-label e-nusx-8">
                მოთხოვნის შედარება მოხდეს
                <strong>დასახელებით</strong>
              </span>
            </label>
            <hr class="border-light mt-3" />
          </b-card>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <b-card bg-variant="transparent" border-variant="secondary" class="shadow-none mb-4">
            <div class="card-title with-elements">
              <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                მოქმედი შედარების ალგორითმი
                <strong class="text-danger">იურიდიული პირის</strong> შემთხვევაში
              </h5>
            </div>
            <div class="callout callout-warning" v-if="!juridical.logic1 && !juridical.logic2">
                <h5 class="e-mtavr-17">ყურადღება!</h5>
                <p class="e-nusx-8">ამ დროისათვის სისტემაში არ მოქმედებს მოთხოვნის თეთრ სიასთან შედარების არცერთი ლოგიკა.</p>
                <hr>
                <p class="e-nusx-8">გთხოვთ ყურადღებით აირჩიოთ თქვენთვის მისაღები ლოგიკა ერთი ან რამოდენიმე</p>
            </div>
            <div class="callout callout-success" v-else>
                <h5 class="e-mtavr-17">არჩევანის შესაბამისად მოთხოვნა თეთრ სიასთან შედარდება შემდეგი ლოგიკით</h5>
                <p class="e-nusx-8" v-if="juridical.logic1"><strong>ლოგიკა 1</strong> - მოთხოვნის პარამეტრები შედარდება თეთრი სიის ჩანაწერის სახელს, გვარს და პირად ნომერს.</p>
                <hr v-if="juridical.logic1">
                <p class="e-nusx-8" v-if="juridical.logic1 && juridical.logic2"><span class="badge badge-warning">ყურადღება</span> - <strong> ლოგიკა 1</strong>-ით ვერცერთი დამთხვევის გამოვლენისას ამოქმედდება შემდეგი ლოგიკა</p>
                <hr v-if="juridical.logic1 && juridical.logic2">
                <p class="e-nusx-8" v-if="juridical.logic2"><strong>ლოგიკა 2</strong> - მოთხოვნის პარამეტრები შედარდება თეთრი სიის ჩანაწერის სახელს, გვარს და პირად ნომერს.</p>
                <hr v-if="juridical.logic2">
                <p class="e-nusx-8"><strong>შერჩეული ლოგიკით პირდაპირი დამთხვევის შემთხვევაში შემოსული მოთხოვნა ავტომატურად დადასტურდება.</strong></p>
            </div>
          </b-card>
      </div>
    </div>
    <i class="badge badge-danger mb-1" v-if="individualErrorMsg">შეცდომა</i><span class="e-nusx-8" v-if="individualErrorMsg"><small> გთხოვთ აირჩიოთ შედარების ალგორითმი <span class="text-danger">ფიზიკური პირის</span> შემთხვევაში</small></span><br/>
    <i class="badge badge-danger" v-if="juridicalErrorMsg">შეცდომა</i><span class="e-nusx-8" v-if="juridicalErrorMsg"><small> გთხოვთ აირჩიოთ შედარების ალგორითმი <span class="text-danger">იურიდიული პირის</span> შემთხვევაში</small></span><br/>
    <button class="btn btn-primary mt-3" @click="saveWLSettings">შენახვა</button>
    <button class="btn btn-secondary mt-3" @click="clearForm">გასუფთავება</button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      individualErrorMsg: false,
      juridicalErrorMsg: false,
      individual: {
        logic1: false,
        logic2: false,
        logic3: false
      },
      juridical: {
        logic1: false,
        logic2: false
      }
    }
  },
  methods: {
    saveWLSettings () {
      this.individualErrorMsg = false
      this.juridicalErrorMsg = false
      if (!this.individual.logic1 && !this.individual.logic2 && !this.individual.logic3) {
        this.individualErrorMsg = true
      }
      if (!this.juridical.logic1 && !this.juridical.logic2) {
        this.juridicalErrorMsg = true
      }
      if (!this.individualErrorMsg && !this.juridicalErrorMsg) {
      }
    },
    clearForm () {
      this.individualErrorMsg = false
      this.juridicalErrorMsg = false
      this.individual = {
        logic1: false,
        logic2: false,
        logic3: false
      }
      this.juridical = {
        logic1: false,
        logic2: false
      }
    }
  }
}
</script>
